const standardDeviation = function (numbersArr) {
  let meanVal = mean(numbersArr)

  let SDprep = 0
  for (let key in numbersArr) {
    SDprep += Math.pow((parseFloat(numbersArr[key]) - meanVal), 2)
  }
  let SDresult = Math.sqrt(SDprep / numbersArr.length)
  return SDresult
}

const mean = function (numbersArr) {
  let total = 0
  for (let key in numbersArr) {
    total += numbersArr[key]
  }
  return total / numbersArr.length
}

export {
  standardDeviation,
  mean
}



// WEBPACK FOOTER //
// ./src/app/common/math/utility.js